<template>
    <div class="banner-two">
      <div class="left">
        <h2>好未来旗下“未来魔法校”</h2>
        <p>将为教育行业提供完整的直播、教研、AI系统解决方案，提升行业科技服务和数字化水平。</p>
        <ul class="product-list">
          <ProductItem v-for="item in prodList" :key="item.id" :prodInfo="item" @productItemClicked="handleClickItem"></ProductItem>
        </ul>
      </div>
      <div class="right">
        <div class="main-bg-right"></div>
      </div>
    </div>
</template>
<script>
// import * as animationData from '@/../public/lottie/data.json'
import ProductItem from './product-item.vue'
export default {
  props: {
    vm: {
      type: Object,
      default: () => {}
    }
  },
  components: { ProductItem },
  data () {
    return {
      defaultOptions: { animationData: this.vm.jsonData },
      prodList: [{
        name: '未来魔法校',
        desc: '培训机构服务平台',
        logoUrl: require('@/assets/pngs/icon_mfx.png'),
        type: 1,
        redirectUrl: '/production/content', // 特别的，这里跳转到好课的
        redirectType: 'newRouter',
        clickType: true
      },
      {
        name: '直播云',
        desc: '多场景直播服务平台',
        logoUrl: require('@/assets/pngs/icon_zby.png'),
        type: 2,
        redirectUrl: process.env.VUE_APP_ZBY_WEB,
        redirectType: 'newPage',
        clickType: true
      },
      {
        name: '教研云',
        desc: '一站式教研服务平台',
        logoUrl: require('@/assets/pngs/icon_jyy.png'),
        type: 3,
        redirectUrl: 'https://www.jiaoyanyun.com',
        redirectType: 'newPage',
        clickType: true
      }
      ]
    }
  },
  methods: {
    handleClickItem (itemInfo) {
      if (itemInfo.redirectType === 'newPage') {
        window.open(itemInfo.redirectUrl)
      } else {
        this.goPath(itemInfo.redirectUrl)
      }
    },
    goPath (path) {
      this.$router.push(path)
    }
  }
}
</script>
<style lang="scss" scoped>
    .banner-two{
        width: $main-width;
        height: 700px;
        margin: -40px auto 0;
        // background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/banner-1.png');
        // background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        .left {
          width: 535px;
          margin-top: 176px;
          margin-left: 81px;
          text-align: left;
          padding-top: 75px;
          padding-left: 6px;
          font-family: PingFangSC-Regular;
          h2 {
            font-size: 28px;
            font-weight: 500;
            color: #282828;
            line-height: 28px;
          }
          p {
            width: 530px;
            margin-top: 16px;
            font-weight: 400;
            color: #282828;
            line-height: 23px;
            font-size: 15px;
          }
          .product-list {
            width: 540px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 0;
            margin-top: 53px;
            .product-item {
              width: 270px;
              display: flex;
              margin-bottom: 40px;
              .short-desc {
                margin-left: 21px;
                padding-top: 10px;

                span {
                  font-weight: 500;
                }
                div {
                  font-size: 11px;
                  font-weight: 500;
                  color: #707070;
                  line-height: 19px;
                  margin-top: 1s5px;
                }
              }
            }
          }
        }
        .right {
          width: 400px;
          margin-top: 176px;
          flex:1;
          .main-bg-right {
            width:693px;
            height: 488px;
            margin-left: 5px;
            background: url(../../../../assets/pngs/main-bg-right@2x.png) no-repeat;
            background-size: 693px 488px;
          }

        }
        .banner-message{
            position: absolute;
            top: 259px;
            left: 81px;
            width: 652px;
            padding: 30px 19px 30px 28px;
            background:rgba(248,249,252,0.2);
            border:none;
            border-radius:10px;
            text-align: left;
            .title-logo{
                width: 208px;
                height: 31px;
                margin-bottom: 25px;
                &.isImg{
                  width: 246px;
                  height: 68px;
                  margin-bottom: 10px;
                }
            }
            .message{
                font-size:18px;
                font-family:PingFangSC-Regular;
                color:#ffffff;
                text-shadow:0px 2px 0px rgba(0, 0, 0, 0.14);
                line-height: 27px;
            }
        }
    }
</style>
